const grades = {
  name: '题型：',
  label: 'question',
  val: [
    {
      name: '全部',
      val: '-1'
    },
    {
      name: '选择题',
      val: '1'
    },
    {
      name: '填空题',
      val: '2'
    },
    {
      name: '解答题',
      val: '3'
    }
  ]
}

const sections = {
  name: '地区：',
  label: 'section',
  val: [
    { name: '全部', val: 0 },
    { name: '北京', val: 110000 },
    { name: '天津', val: 120000 },
    { name: '河北', val: 130000 },
    { name: '山西', val: 140000 },
    { name: '辽宁', val: 210000 },
    { name: '吉林', val: 220000 },
    { name: '上海', val: 310000 },
    { name: '江苏', val: 320000 },
    { name: '浙江', val: 330000 },
    { name: '安徽', val: 340000 },
    { name: '福建', val: 350000 },
    { name: '江西', val: 360000 },
    { name: '山东', val: 370000 },
    { name: '河南', val: 410000 },
    { name: '湖北', val: 420000 },
    { name: '湖南', val: 430000 },
    { name: '广东', val: 440000 },
    { name: '广西', val: 450000 },
    { name: '海南', val: 460000 },
    { name: '重庆', val: 500000 },
    { name: '四川', val: 510000 },
    { name: '贵州', val: 520000 },
    { name: '云南', val: 530000 },
    { name: '西藏', val: 540000 },
    { name: '陕西', val: 610000 },
    { name: '甘肃', val: 620000 },
    { name: '青海', val: 630000 },
    { name: '宁夏', val: 640000 },
    { name: '新疆', val: 650000 },
    { name: '台湾', val: 710000 },
    { name: '香港', val: 810000 },
    { name: '澳门', val: 820000 },
    { name: '内蒙古', val: 150000 },
    { name: '黑龙江', val: 230000 }
  ]
}

const years = {
  name: '年份：',
  label: 'year',
  val: [
    { name: '全部', val: 0 },
    { name: '2019', val: 2019 },
    { name: '2018', val: 2018 },
    { name: '2017', val: 2017 },
    { name: '2016', val: 2016 },
    { name: '2015', val: 2015 }
  ]
}

const difficulty = {
  name: '难度：',
  label: 'difficulty',
  val: [
    {
      name: '全部',
      val: '-1'
    },
    {
      name: '容易',
      val: '1'
    },
    {
      name: '较易',
      val: '2'
    },
    {
      name: '中等',
      val: '3'
    },
    {
      name: '较难',
      val: '4'
    },
    {
      name: '困难',
      val: '5'
    }
  ]
}

const filterData = [grades, difficulty, years, sections]

export default filterData
